import { configureStore } from "@reduxjs/toolkit";

import createRootReducer from "./index";
import { appConfigMiddleware } from "../middlewares/AppConfigs";
import logger from "../middlewares/Logger";

const store = configureStore({
  reducer: createRootReducer,
  middleware: (getDefaultMiddleware: any) => {
    return getDefaultMiddleware().concat(appConfigMiddleware).concat(logger);
  },
});

export type ApplicationState = ReturnType<typeof createRootReducer>;

export default store;
